import { isString } from 'lodash';

import { P2PProviderType } from 'enums';
import { PayinFlowMode } from 'enums/payin-flow-mode.enum';

// Mirrors backend libs/app/src/p2p-providers/utils/payin-flow-mode.utils.ts — keep both in sync.
const PAYIN_FLOW_MODE_TYPES = new Set<string>([
  P2PProviderType.Argos,
  P2PProviderType.BNPay,
  P2PProviderType.Havalepayhera,
  P2PProviderType.HighHelp,
  P2PProviderType.PayMatrix,
  P2PProviderType.Payscrow,
  P2PProviderType.TeleStore,
  P2PProviderType.Tokyo,
]);

// Per-provider spellings stored before the payin flow modes were unified.
const PAYIN_FLOW_MODE_BY_VALUE: Record<string, PayinFlowMode> = {
  order_with_form: PayinFlowMode.OrderWithForm,
  requisite: PayinFlowMode.Requisite,
  p2p: PayinFlowMode.Requisite,
  payment_form: PayinFlowMode.PaymentForm,
  payment_link: PayinFlowMode.PaymentForm,
  redirect: PayinFlowMode.PaymentForm,
};

export const hasPayinFlowMode = (
  providerType?: P2PProviderType | string,
): boolean => !!providerType && PAYIN_FLOW_MODE_TYPES.has(providerType);

export const normalizePayinFlowMode = (
  flowMode?: unknown,
): PayinFlowMode | undefined =>
  isString(flowMode)
    ? PAYIN_FLOW_MODE_BY_VALUE[flowMode.trim().toLowerCase()]
    : undefined;

export const withNormalizedPayinFlowMode = <
  T extends Record<string, any> | undefined,
>(
  providerType: P2PProviderType | string | undefined,
  credentials: T,
): T =>
  hasPayinFlowMode(providerType)
    ? ({
        ...credentials,
        flowMode:
          normalizePayinFlowMode(credentials?.flowMode) ??
          PayinFlowMode.Requisite,
      } as T)
    : credentials;
